// @flow

import { useMemo } from 'react';
import { validateChileanDocument } from '../../../../prs/chile/validation/chilean-document';
import type { SodexoUserInputValues, SodexoUserInputValuesKey } from './user-input-values';

export type SodexoUserInputValidations = {
  [SodexoUserInputValuesKey]: SodexoUserInputValidation,
};

export type SodexoUserInputValidation = ?string;

export function useSodexoUserInputValidations(sodexoUserInputValues: SodexoUserInputValues): SodexoUserInputValidations {
  const userChileanRut = useValidationMemo(sodexoUserInputValues, 'userChileanRut');

  return useMemo(() => {
    return { userChileanRut };
  }, [userChileanRut]);
}

const VALIDATORS: { [SodexoUserInputValuesKey]: (string) => ?string } = {
  userChileanRut: validateUserChileanRut,
};

function useValidationMemo(sodexoUserInputValues: SodexoUserInputValues, key: SodexoUserInputValuesKey): ?string {
  return useMemo(() => {
    return VALIDATORS[key](sodexoUserInputValues[key]);
  }, [sodexoUserInputValues[key]]);
}

function validateUserChileanRut(userRut: string): ?string {
  if (!userRut) {
    return 'empty';
  }
  if (validateChileanDocument(userRut)) {
    return 'invalid';
  }
  return null;
}
